import React from 'react';
import { betSectionTabsName, globalTranslationKeys } from '../../../../enums';

const BetSectionTabsNames = ({ activeTabName, handleTabChange, t }) => {
  const { markets, manual } = betSectionTabsName;
  const { Ranges, Manual } = globalTranslationKeys;
  return (
    <div className='oddball-game-tab-wrp'>
      <div
        className={`oddball-game-tab-item ${activeTabName === markets ? 'active' : ''} `}
        title={t(Ranges)}
        onClick={() => handleTabChange(markets)}
      >
        <p className='oddball-game-tab-item-text '>{t(Ranges)}</p>
      </div>
      <div
        className={`oddball-game-tab-item ${activeTabName === manual ? 'active' : ''}`}
        title={t(Manual)}
        onClick={() => handleTabChange(manual)}
      >
        <p className='oddball-game-tab-item-text'>{t(Manual)}</p>
      </div>
      <div className='oddball-game-tab-active'>
        <div className='oddball-game-tab-active-bg' />
      </div>
    </div>
  );
};

export default BetSectionTabsNames;
